// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "shift".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "shift" table (1:1 with a DB row, on the wire). */
export const shiftAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    practitionerId: z.string(),
    locationId: z.string().nullable(),
    dayOfWeek: z.number().nullable(),
    date: z.string().nullable(),
    startMinutes: z.number().nullable(),
    endMinutes: z.number().nullable(),
    isOff: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=shift.js.map